import { render, staticRenderFns } from "./ModalCreateMenssagesMobile.vue?vue&type=template&id=1ca07508&scoped=true"
import script from "./ModalCreateMenssagesMobile.vue?vue&type=script&lang=js"
export * from "./ModalCreateMenssagesMobile.vue?vue&type=script&lang=js"
import style0 from "./ModalCreateMenssagesMobile.vue?vue&type=style&index=0&id=1ca07508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca07508",
  null
  
)

export default component.exports